"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementReferenceFields = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
function ElementReferenceFields({ prefix, required }) {
    const theme = (0, react_1.useTheme)();
    return (react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.selector`, label: 'Element Selector', extra: 'This is a CSS selector used to find the element to show to the user.', required: required ? { value: true, message: 'A selector is required.' } : undefined },
        react_2.default.createElement(react_1.Input, { style: { fontFamily: theme['@code-family'] }, placeholder: '#test-element' })));
}
exports.ElementReferenceFields = ElementReferenceFields;
//# sourceMappingURL=ElementReferenceFields.js.map